module.exports = __webpack_public_path__ + "assets/2601661a93c94712d92854830fb73b78.png";